export default __webpack_public_path__ + "static/media/sightXWithRepdataLogo.3e7eacb1.svg";